import { t } from "@travily/i18n";
import { MoneyField } from "@ui/components/MoneyField";
import { FeeTransparency } from "@/components/FeeTransparency/FeeTransparency";
import type { ListingFieldCopy, ListingType } from "./types";

const COLOR = "green" as const;

// i18n-tasks-use t('web.listings.fields.price_amount.product.heading')
// i18n-tasks-use t('web.listings.fields.price_amount.product.helper')
// i18n-tasks-use t('web.listings.fields.price_amount.service.heading')
// i18n-tasks-use t('web.listings.fields.price_amount.service.helper')

export function priceAmountFieldCopy(listingType: ListingType): ListingFieldCopy {
  return {
    heading: t(`web.listings.fields.price_amount.${listingType}.heading`),
    helper: t(`web.listings.fields.price_amount.${listingType}.helper`),
  };
}

export interface PriceAmountFieldProps {
  /** ISO currency the price is entered and displayed in (the seller's currency). */
  currency: string;
  /** Field error, or undefined when valid. */
  error?: string;
  listingType: ListingType;
  onChange: (value: string) => void;
  /** Platform commission rate (0–1) shown in the take-home ledger. */
  platformFeeRate: number;
  /** Price in minor units for the ledger, or null until a positive amount is entered. */
  priceCents: number | null;
  /** Current price as a major-unit amount string (empty when unset). */
  value: string;
}

export function PriceAmountField({
  currency,
  error,
  listingType,
  onChange,
  platformFeeRate,
  priceCents,
  value,
}: PriceAmountFieldProps) {
  const { heading } = priceAmountFieldCopy(listingType);

  return (
    <div className="text-left">
      <MoneyField
        color={COLOR}
        currency={currency}
        errorMessage={error}
        isInvalid={Boolean(error)}
        isLabelHidden
        label={heading}
        onChange={onChange}
        placeholder={t("web.listings.fields.price_amount.placeholder")}
        value={value}
      />
      <FeeTransparency currency={currency} platformFeeRate={platformFeeRate} priceCents={priceCents} />
    </div>
  );
}
